import { Component, OnInit, Input, ViewChild, ElementRef, ViewChildren, Output, EventEmitter } from '@angular/core';
import { CharacteristicObject } from 'src/app/models/characteristics/characteristic/characteristic-object.model';
import { SingleCharacteristicObject } from 'src/app/models/characteristics/characteristic/single-characteristic-object.model';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';

@Component({
  selector: 'app-field',
  templateUrl: './field.component.html',
  styleUrls: ['./field.component.css']
})
export class FieldComponent implements OnInit {

  @Input() characteristic: SingleCharacteristicObject;
  @Input() editable: boolean;
  @Output() characteristicEvent = new EventEmitter<CharacteristicObject>();

  characteristicOriginal: SingleCharacteristicObject;
  newValue: string;

  diffPhrase: string;
  value: string;
  hover: boolean;
  characToDisplay: string;

  autofocus: boolean;

  placeholder: string = "vacío";

  private static PASSWORD_PATTERN = /password/i;

  @ViewChild('valueInput', { static: false }) valueInput: ElementRef;

  constructor(private notificationsService: NotificationsService) {

  }

  ngOnInit() {
    this.autofocus = false;
    this.diffPhrase = '';
    this.characteristicOriginal = this.characteristic.clone();
  }

  ngAfterViewChecked() {
    if (this.autofocus === true) {
      this.valueInput.nativeElement.focus();
      this.autofocus = false;
    }
  }

  onEdit() {
    if (!this.editable) return;

    this.characteristic.mode = 'EDITING';
    this.newValue = this.characteristic.value;
    this.autofocus = true;
  }

  public resetInputValue() {
    this.characteristic.value = this.characteristicOriginal.value;
    this.newValue = this.characteristicOriginal.value;
    this.valueInput.nativeElement.focus();
  }

  public acceptNewInputValue() {
    if (this.isPasswordCharacteristic() && /\s/.test(this.newValue)) {
      this.notificationsService.showNotification('La contraseña no puede contener espacios', NotificationLevel.ERROR);
      return;
    }
    if (this.isPasswordCharacteristic() && this.newValue && this.newValue.length > 14) {
      this.notificationsService.showNotification('La contraseña no puede tener más de 14 caracteres', NotificationLevel.ERROR);
      return;
    }
    if (this.newValue === this.characteristicOriginal.value) {
      this.setEditValue("DEFAULT");
    } else {
      this.setEditValue("EDITED");
    }
  }

  private isPasswordCharacteristic(): boolean {
    return FieldComponent.PASSWORD_PATTERN.test(this.characteristic.id);
  }

  public setEditValue(mode: string) {
    this.characteristic.value = this.newValue;
    this.characteristic.mode = mode;
    this.diffPhrase = 'Valor anterior: ' + this.characteristicOriginal.value + '';
    this.characteristicEvent.emit(this.characteristic);
  }

  copyToClipboard(id: string) {
    var copyText = document.getElementById(id);
    var textArea = document.createElement("textarea");
    textArea.value = copyText.textContent.trim();
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("Copy");
    textArea.remove();
  }

}
